import { buildApiUrl, getApiBase } from '@/utils/apiBase'
import { emitMemberClientTelemetry } from './diagnosticTelemetry'

export const EXPECTED_MEMBERS_API_HOST = 'privana-api.onrender.com'

export function resolvedApiOriginHost({ apiBase = getApiBase(), locationOrigin = globalThis.location?.origin } = {}) {
  try { return new URL(apiBase || locationOrigin).host || null } catch { return null }
}

export function detectMembersApiOriginMismatch(options = {}) {
  const actualHost = resolvedApiOriginHost(options)
  const expectedHost = options.expectedHost || EXPECTED_MEMBERS_API_HOST
  if (!actualHost || actualHost === expectedHost) return null
  return emitMemberClientTelemetry({ event: 'members_api_origin_mismatch', expectedHost, actualHost })
}

export async function sendMembersTransportDiagnostic(clubCode, { fetchImpl = globalThis.fetch, now = () => performance.now() } = {}) {
  const requestPathname = `/api/members-portal/${encodeURIComponent(clubCode)}/transport-diagnostic`
  const pathname = '/api/members-portal/:clubCode/transport-diagnostic'
  const url = buildApiUrl(requestPathname)
  const originHost = resolvedApiOriginHost()
  detectMembersApiOriginMismatch()
  const startedAt = now()
  try {
    const response = await fetchImpl(url, { method: 'GET', cache: 'no-store', credentials: 'omit' })
    const body = await response.json().catch(() => null)
    return emitMemberClientTelemetry({
      event: 'members_transport_diagnostic', originHost, pathname, status: response.status,
      requestId: typeof body?.requestId === 'string' ? body.requestId : null,
      deploymentSha: typeof body?.deploymentSha === 'string' ? body.deploymentSha : null,
      fetchMs: now() - startedAt, errorCode: response.ok ? null : 'http_error',
    })
  } catch (error) {
    return emitMemberClientTelemetry({
      event: 'members_transport_diagnostic', originHost, pathname, status: 0,
      fetchMs: now() - startedAt, errorCode: error?.name === 'AbortError' ? 'abort' : 'network',
    })
  }
}
